'use client';

import { c as _c } from "react/compiler-runtime";
import { PreferencesEnum } from '@shared/all/domains/user';
import useAuth from '@shared/utils/hooks/useAuth';
import usePreference from '@shared/utils/hooks/usePreference';
import useUser from '@shared/utils/hooks/useUser';
import { client, service } from '../../utils/trpc';
import { ToggleItem } from '../UI/ToggleItem';
const Privacy = () => {
  const $ = _c(40);
  const {
    currentUser
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      client,
      service
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    initializeUser
  } = useAuth(t0);
  const {
    preferenceState,
    updatePreferences
  } = usePreference(client);
  let t1;
  if ($[1] !== currentUser.isPrivate || $[2] !== initializeUser) {
    t1 = async () => {
      await client.users.updateUserType.mutate({
        type: "PRIVATE",
        enabled: !currentUser.isPrivate
      });
      await initializeUser();
    };
    $[1] = currentUser.isPrivate;
    $[2] = initializeUser;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updatePrivate = t1;
  let t2;
  if ($[4] !== currentUser.isIncognito || $[5] !== initializeUser) {
    t2 = async () => {
      await client.users.updateUserType.mutate({
        type: "INCOGNITO",
        enabled: !currentUser.isIncognito
      });
      await initializeUser();
    };
    $[4] = currentUser.isIncognito;
    $[5] = initializeUser;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const updateIncognito = t2;
  let t3;
  if ($[7] !== updatePreferences) {
    t3 = () => updatePreferences(PreferencesEnum.awardsVisibilityPrivate);
    $[7] = updatePreferences;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== preferenceState.awardsVisibilityPrivate || $[10] !== t3) {
    t4 = <ToggleItem title="Hide my Awards" description="The awards you receive won't be visible to anyone else." state={preferenceState.awardsVisibilityPrivate} onChange={t3} />;
    $[9] = preferenceState.awardsVisibilityPrivate;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== updatePreferences) {
    t5 = () => updatePreferences(PreferencesEnum.hidePostsOnProfile);
    $[12] = updatePreferences;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== preferenceState.hidePostsOnProfile || $[15] !== t5) {
    t6 = <ToggleItem title="Hide my Posts on Profile Page" description="This won't show any of your posts on your profile page." state={preferenceState.hidePostsOnProfile} onChange={t5} />;
    $[14] = preferenceState.hidePostsOnProfile;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== updatePreferences) {
    t7 = () => updatePreferences(PreferencesEnum.hideProfileHistory);
    $[17] = updatePreferences;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== preferenceState.hideProfileHistory || $[20] !== t7) {
    t8 = <ToggleItem title="Hide my Profile History" description="This won't show any of your profile history your profile page." state={preferenceState.hideProfileHistory} onChange={t7} />;
    $[19] = preferenceState.hideProfileHistory;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== updatePreferences) {
    t9 = () => updatePreferences(PreferencesEnum.factiiiCountPrivate);
    $[22] = updatePreferences;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== preferenceState.factiiiCountPrivate || $[25] !== t9) {
    t10 = <ToggleItem title="Hide my Factiii Count" description="Your Factiii count won't be visible to other users." state={preferenceState.factiiiCountPrivate} onChange={t9} />;
    $[24] = preferenceState.factiiiCountPrivate;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== currentUser.isPrivate || $[28] !== updatePrivate) {
    t11 = <ToggleItem title="Private" description="Only you can see your profile and posts. Note: your votes and comments on other people's posts are still visible to those post owners." state={currentUser.isPrivate} onChange={updatePrivate} />;
    $[27] = currentUser.isPrivate;
    $[28] = updatePrivate;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== currentUser.isIncognito || $[31] !== updateIncognito) {
    t12 = <ToggleItem title="Incognito" description="We don't record your IP address or browser/device info for any activity on this account. Affects new activity only; existing records aren't scrubbed." state={currentUser.isIncognito} onChange={updateIncognito} />;
    $[30] = currentUser.isIncognito;
    $[31] = updateIncognito;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t4 || $[37] !== t6 || $[38] !== t8) {
    t13 = <div className="flex flex-col items-center">{t4}{t6}{t8}{t10}{t11}{t12}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t4;
    $[37] = t6;
    $[38] = t8;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  return t13;
};
export default Privacy;